// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponEnrollmentPatientMedicalBenefitProgramIdPatientMedicalBenefitResponse {
    static getAttributeTypeMap() {
        return CouponEnrollmentPatientMedicalBenefitProgramIdPatientMedicalBenefitResponse.attributeTypeMap;
    }
}
CouponEnrollmentPatientMedicalBenefitProgramIdPatientMedicalBenefitResponse.discriminator = undefined;
CouponEnrollmentPatientMedicalBenefitProgramIdPatientMedicalBenefitResponse.additionalProperties = false;
CouponEnrollmentPatientMedicalBenefitProgramIdPatientMedicalBenefitResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ExtEnrollmentPatientLookupResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=couponEnrollmentPatientMedicalBenefitProgramIdPatientMedicalBenefitResponse.js.map